'use client';

import Link from 'next/link';

import { TextKeyValuePair } from '@/components/atomic/atoms';
import { parseFormatPriceNumberValueFromAPI } from '@/lib/numberStringUtils';
import { PARTNER_PORTAL_URL } from '@/services/connections.service';
import { getAuthIdentity } from '@/services/identity.service';
import getInitiateWhatsappChatLinkForSARA from '@/services/landingPage.service';

const ProductPriceLabel = ({ productPartners }) => {
  const { partnerOrgId } = getAuthIdentity();
  const { unitPartnerPrice, maxInventory } = productPartners.find(
    ({ partnerId }) => partnerId === partnerOrgId
  );

  const { pathname } = new URL(window.location.href);
  const pageURLWithoutQueryParam = `${PARTNER_PORTAL_URL}${pathname}`;

  const formattedMessage = `Hi Sara! I want to share latest info/report issues on product ${pageURLWithoutQueryParam}`;

  return (
    <div>
      <div className='p-2 md:p-5 border border-brand rounded-md'>
        <div className='flex flex-col items-start md:gap-4 gap-2'>
          <TextKeyValuePair
            {...{
              className: 'flex flex-row',
              label: 'Inventory:',
              labelClass: 'font-light text-base md:text-xl',
              spaceTop: '',
              value: `${maxInventory} Units`,
              valueClassName: 'ms-2 font-medium text-base md:text-xl'
            }}
          />
          <TextKeyValuePair
            {...{
              className: 'flex flex-row',
              label: 'Unit Price:',
              labelClass: 'font-light text-base md:text-xl',
              spaceTop: '',
              value:
                unitPartnerPrice > 0
                  ? `${parseFormatPriceNumberValueFromAPI(unitPartnerPrice)} AED`
                  : 'Not Available',
              valueClassName: 'ms-2 font-medium text-base md:text-xl'
            }}
          />
        </div>
      </div>
      <div className='text-xs md:text-sm font-light mt-2 italic'>
        Get in touch with
        <Link
          href={getInitiateWhatsappChatLinkForSARA({
            messageBody: formattedMessage
          })}
          title='Click to contact Sara'
          className='text-brand'
          target='_blank'
        >
          {' '}
          Sara{' '}
        </Link>
        to report any issues or share latest info.
      </div>
    </div>
  );
};

export default ProductPriceLabel;
